import {Base} from "@/api/Base"

export class EmployeeList extends Base {
    path = "employee/list"
}